module.exports = __webpack_public_path__ + "static/img/sec2-content03-img05@m.7c150ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ybTour/sec2-content03-img05@m.jpg
// module id = /m7E
// module chunks = 0